(function () {
  'use strict';
  var lists = '.ol-fuss__zahlarten, .ol-warum__zahlen, .ol-px__icons, .payment-icons__list';
  var scheduled = false;
  function labelPayments() {
    document.querySelectorAll(lists).forEach(function (list) {
      list.querySelectorAll('li').forEach(function (item) {
        if (item.hasAttribute('data-ol-zahlname')) return;
        var icon = item.querySelector('svg');
        if (!icon) return;
        var title = Array.prototype.find.call(icon.children, function (child) {
          return child.tagName && child.tagName.toLowerCase() === 'title';
        });
        var name = title && title.textContent.trim();
        if (!name) return;
        item.setAttribute('data-ol-zahlname', name);
        icon.setAttribute('tabindex', '0');
      });
    });
  }
  function start() {
    labelPayments();
    document.addEventListener('shopify:section:load', labelPayments);
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        labelPayments();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
